import { Injectable } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import { AlertService } from './alert.service';
import { LoginStore, SignupStore } from './store';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  banks = [];
  ussdBanks = [];
  filteredBanks: any[];
  states: Array<object>;

  constructor(
    private auth: AuthenticationService,
    private loginStore: LoginStore,
    private signupStore: SignupStore,
    private alertService: AlertService,
  ) {}

  errorText = {
    oops: 'Oops! Please check your internet connection and try again. ',
    persists: 'If problem persists, please be patient. Service would be restored soon'
  };

  getStates() {
    this.auth.getStates().subscribe(
      (response: any) => {
        console.log(response);
        this.states = response;
        this.signupStore.setStates(this.states);
      },
      (error) => {
        this.alertService.stopLoading();
        console.log(error);
      }
    );
  }

  getBanks() {
    this.auth.getBanks().subscribe(
      (response: any) => {
        console.log(response);
        this.banks = response;
        this.loginStore.setBanks(this.banks);

        this.banks.find((bank: any) => {
          if (this.loginStore.getReferralId() === '381') {
            if (bank.cbn === '084') {
              this.filteredBanks = [bank];
              this.loginStore.setFilteredBanks(this.filteredBanks);
            }
          } else {
            this.filteredBanks = this.banks;
            this.loginStore.setFilteredBanks(this.filteredBanks);
          }
        });
      },
      (error) => {
        this.alertService.stopLoading();
        console.log(error);
      }
    );
    this.auth.getUssdBanks().subscribe((response: any) => {
      console.log(response);
      this.ussdBanks = response;
      this.loginStore.setUssdBanks(this.ussdBanks);
    });
  }
}
